import { useState, useRef, useCallback, createElement } from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';
import cn from 'classnames';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';
import S from './Tabs.styl.js';

function isId(id) {
    return ['string', 'number'].includes(typeof id);
}
function Tabs(props) {
    const { size = 'm', contentClassName, items, onChange, renderAll, activeId: initialId, children, ...rest } = props;
    const [activeId, setActiveId] = useState(isId(initialId) ? initialId : items[0].id);
    const tabsContent = useRef([]);
    const onTabClick = useCallback((e, { id, onClick } = {}) => {
        // @ts-ignore
        if (onClick && !onClick(e)) {
            e.peventDefault();
            return;
        }
        setActiveId(id);
        onChange?.(id);
    }, []);
    tabsContent.current = [];
    const tabs = items.map((params) => {
        const { id, label, forceRender, content, contentClassName: currContentClassName, ...rest } = params;
        const isActive = activeId === id;
        const tabContent = typeof content === 'function' ? content() : content;
        if (renderAll || forceRender || isActive) {
            tabsContent.current.push(jsx("div", { className: cn(contentClassName, currContentClassName, !isActive && S.inactive), children: tabContent }, id));
        }
        return (createElement(Button, { ...rest, size: size, key: id, onClick: e => onTabClick(e, params), checked: isActive }, label));
    });
    if (typeof children === 'function') {
        return children({
            tabs: jsx(ButtonGroup, { ...rest, children: tabs }),
            content: tabsContent.current,
        });
    }
    return jsx(Fragment, { children: tabsContent.current });
}

export { Tabs };
